function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#BABABA",
  d: "M15.77 18l.09-.59c.07-.52.26-.99.57-1.4.3-.4.77-.93 1.39-1.57.7-.68 1.24-1.3 1.62-1.87a3.52 3.52 0 00-.04-3.86c-.4-.54-.95-.96-1.65-1.26A6.2 6.2 0 0015.32 7c-.98 0-1.96.16-2.93.48A6.8 6.8 0 0010 8.77l.95 2.05c.69-.51 1.39-.9 2.1-1.18.72-.28 1.4-.41 2.04-.41.65 0 1.15.14 1.5.42.37.29.55.67.55 1.17 0 .44-.1.83-.32 1.18-.2.35-.53.78-.96 1.29-.57.65-1.01 1.25-1.31 1.8a4.2 4.2 0 00-.45 2.04V18h1.67zm.23 5v-3h-3v3h3z"
})));